export default __webpack_public_path__ + "static/media/review12.d6b77a8d.jpg";